export function screenTextSponsor(
  isNotBrazilian: boolean,
  isPhysical: boolean,
  isLegal: boolean,
) {
  function showNameFieldLabel(): string {
    if (isNotBrazilian && isLegal) {
      return 'Company name'
    }
    if (isNotBrazilian) {
      return 'First and Last Name'
    }

    if (isPhysical) {
      return 'Nome completo'
    }

    return 'Nome da empresa'
  }

  function showNameFieldPlaceholder(): string {
    if (isNotBrazilian && isLegal) {
      return 'Enter your company name'
    }

    if (isNotBrazilian) {
      return 'Enter your first and last name'
    }
    if (isPhysical) {
      return 'Digite seu nome e sobrenome'
    }

    return 'Digite o nome da empresa'
  }

  const textSponsor = {
    registerType: isNotBrazilian ? 'Type of registration' : 'Tipo de cadastro',
    physical: isNotBrazilian ? 'Individual' : 'Física',
    legal: isNotBrazilian ? 'Organization' : 'Jurídica',
    register: isNotBrazilian ? 'Sign up' : 'Cadastrar',
    form: {
      name: {
        label: showNameFieldLabel(),
        placeholder: showNameFieldPlaceholder(),
      },
      email: {
        label: 'E-mail',
        placeholder: isNotBrazilian ? 'Enter your email' : 'Digite seu e-mail',
      },
      document: {
        label: isNotBrazilian ? 'ID' : isPhysical ? 'CPF' : 'CNPJ',
        placeholder: isNotBrazilian
          ? 'Enter your ID'
          : isPhysical
            ? '000.000.000-00'
            : 'Digite o CNPJ da empresa',
      },

      phone: {
        label: isNotBrazilian ? 'Phone' : 'Telefone',
        placeholder: '(  ) _____-____',
      },
      password: {
        label: isNotBrazilian ? 'Password' : 'Senha',
        placeholder: isNotBrazilian
          ? 'Enter your password'
          : 'Digite sua senha',
      },
      confirmPassword: {
        label: isNotBrazilian ? 'Confirm your password' : 'Confirme sua senha',
        placeholder: isNotBrazilian
          ? 'Enter your password'
          : 'Digite sua senha',
      },
    },
  }

  return { textSponsor }
}
